import { Image } from "react-bootstrap";

const CommentItem = ({ cmt, depth = 0 }) => {
  const isRoot = depth === 0;
  const avatarSize = isRoot ? 36 : 28;
  const hasReplies = cmt.replies && cmt.replies.length > 0;

  return (
    <div className={isRoot ? "d-flex mb-3 pb-3 border-bottom" : "d-flex mb-2"}>
      <Image
        roundedCircle
        width={avatarSize}
        height={avatarSize}
        src={cmt.profile_image}
        className="me-3 mt-1"
        style={{ objectFit: 'cover', flexShrink: 0 }}
      />
      <div className="w-100">
        <div className="d-flex justify-content-between align-items-center">
          <span className="fw-bold" style={{ fontSize: isRoot ? '0.875rem' : '0.82rem' }}>{cmt.member_name}</span>
          <small style={{ fontSize: '0.75rem' }}>{cmt.created_at}</small>
        </div>
        <div className="mt-1 text-dark" style={{ fontSize: isRoot ? '0.875rem' : '0.82rem' }}>{cmt.comment}</div>

        {/* Recursively render replies */}
        {hasReplies && (
          <div className="mt-3 ps-3 border-start border-2 border-primary">
            {cmt.replies.map((reply, ridx) => (
              <CommentItem key={ridx} cmt={reply} depth={depth + 1} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentItem;